<!--Menu Bar-->
<div class="lock-to-top" style="background-color: #ffffff">
	<!--School Select-->
	<div class="selector-body">
		<div class="selector-item">
			<div>
				<label>School</label>
			</div>

			<div style="margin-left: 10px">
				<!-- <select [disabled]="SchoolLoading == true || EventLoading == true || GroupLoading == true" class="form-control" name="SchoolSelector" style="font-size:smaller;"
					[(ngModel)]="SelectedSchoolID"
					(ngModelChange)="onSchoolChange($event)">
					<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">[{{r.SchoolNumber}}] - {{r.SchoolName}}</option>
				</select> -->

				<caass-schoolselector [ShowAll]="false" [Disabled]="EventLoading == true || GroupLoading == true"> </caass-schoolselector>
			</div>
		</div>

		<div class="selector-item">
			<div>
				<label>Event</label>
			</div>
			<div style="margin-left: 10px">
				<select
					[disabled]="EventLoading == true || GroupLoading == true"
					class="form-control"
					name="EventSelector"
					style="font-size: smaller"
					[(ngModel)]="SelectedEventID"
					(ngModelChange)="onEventChange($event)"
				>
					<!-- (ngModelChange)="onChange()"> -->

					<option *ngFor="let r of lstEvent" [ngValue]="r.EventID">{{ r.EventDescShort }} - {{ FormatDate(r.EventDT) }}</option>
				</select>
			</div>
		</div>

		<div class="selector-item esr-DateSelect">
			<label class="leftMargin">Start Date:</label>
			<p-calendar
				[disabled]="EventLoading == true || GroupLoading == true"
				class="leftMargin"
				(ngModelChange)="onStartDateChange($event)"
				[(ngModel)]="startDate"
				showIcon="true"
				showButtonBar="true"
				name="StartDate"
			></p-calendar>
			<label class="leftMargin">End Date:</label>
			<p-calendar
				[disabled]="EventLoading == true || GroupLoading == true"
				class="leftMargin"
				(ngModelChange)="onEndDateChange($event)"
				[(ngModel)]="endDate"
				showIcon="true"
				showButtonBar="true"
				name="EndDate"
			></p-calendar>
		</div>
	</div>

	<!--Buttons-->
	<div class="button-body flex">
		<!--Refresh Button-->
		<button [disabled]="EventLoading == true || GroupLoading == true" class="btn btn-primary" style="margin-left: 0px" (click)="onRefresh()">
			Refresh
		</button>
		<button [disabled]="EventLoading == true || GroupLoading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onAdd()">Add</button>
		<button [disabled]="EventLoading == true || GroupLoading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onEdit()">Edit</button>
		<button [disabled]="EventLoading == true || GroupLoading == true" class="btn btn-primary" style="margin-left: 5px" (click)="onDelete()">Delete</button>
	</div>
</div>

<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[loading]="EventLoading == true || GroupLoading == true"
		[value]="lstEventDynamicGroups"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedEventDynamicGroup"
		dataKey="EventDynamicGroupID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<!--School Filter?-->
				<th>
					<p-columnFilter field="SchoolName" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterSchoolName
								[ngModel]="value"
								[options]="lstSchoolName"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<th>
					<!--Selection Filter-->
					<p-columnFilter field="DynamicGroupDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDynamicGroupDesc
								[ngModel]="value"
								[options]="lstDynamicGroupDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<!--Selection Value Filter-->
					<p-columnFilter field="DynamicGroupValue" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterDynamicGroupValue
								[ngModel]="value"
								[options]="lstDynamicGroupValue"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<!--Alert Filter-->
					<p-columnFilter field="AlertDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterAlertDesc
								[ngModel]="value"
								[options]="lstAlertDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
				<th>
					<!--Status-->
					<p-columnFilter field="Status" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStatus
								[ngModel]="value"
								[options]="lstStatus"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th pSortableColumn="SchoolName">School<p-sortIcon field="SchoolName"></p-sortIcon></th>
				<th pSortableColumn="DynamicGroupDesc">Selection<p-sortIcon field="DynamicGroupDesc"></p-sortIcon></th>
				<th pSortableColumn="DynamicGroupValue">Selection Value<p-sortIcon field="DynamicGroupValue"></p-sortIcon></th>
				<th pSortableColumn="AlertDesc">Alert<p-sortIcon field="AlertDesc"></p-sortIcon></th>
				<th pSortableColumn="Status">Status<p-sortIcon field="Status"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-eventdynamicgroup>
			<tr [pSelectableRow]="eventdynamicgroup" (dblclick)="onRowDblClick(eventdynamicgroup)">
				<td *ngFor="let col of cols" style="font-weight: bold">
					{{ eventdynamicgroup[col.field] }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<!--Error Message-->
<div class="form-group groups-TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
